import { render, staticRenderFns } from "./MassBedCodes.vue?vue&type=template&id=3f9c7372&"
import script from "./MassBedCodes.vue?vue&type=script&lang=js&"
export * from "./MassBedCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports